import React from 'react'
import './loadingComponent2.css'
import logoSuperior from '../../../../assets/img/loading-logo.png'

export const LoadingComponent2 = ({className}) => {
    return (
        <div className={`formation-loading-container ${className}`}>
            <div className='logo-loading-container'>
                {/* <span className='glow-text'>Cargando usuarios...</span> */}

                <img className='logo-loading' src={logoSuperior} alt="Cargando..." />

            </div>
        </div>
    )
}
